<template>
  <div class="tab-content base-info-root">
    <div class="form">
      <div class="row">
        <div class="tip"><span class="weight">*</span>网站名称</div>
        <div class="value input big-w">
          <el-input
            size="small"
            placeholder="请输入"
            v-model="formIn.websiteName"
          />
        </div>
      </div>
      <div class="h-dot-line"></div>
      <div class="row multi">
        <div class="tip">平台二维码</div>
        <div class="value fill">
          <div class="public-pic-layout">
            <div
              class="fill-pic"
              v-for="(item, index) in formIn.qrCodeList
                ? formIn.qrCodeList
                : []"
              :key="index"
            >
              <div class="item" v-if="item.qrCodeUrl">
                <el-image
                  :ref="`myImg${index}`"
                  :src="item.qrCodeUrl"
                  fit="cover"
                  class="icon"
                  :initial-index="0"
                  :preview-src-list="[item.qrCodeUrl]"
                />
                <div class="preview">
                  <el-image
                    :src="SeeIcon"
                    class="btn-icon"
                    @click="handlePreview(`myImg${index}`)"
                  />
                  <el-image
                    :src="DelIcon"
                    class="btn-icon"
                    @click="handleDeleteImage(index)"
                  />
                </div>
              </div>
              <div v-else class="item add-pic" @click="handleUpload(index)">
                <div class="image-wrap">
                  <el-image :src="AddIcon" />
                </div>
                <span class="text">上传图片</span>
              </div>

              <span class="desp">{{ item.qrCodeName }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row multi">
        <div class="tip">客户端热门搜索关键词</div>
        <div class="value fill">
          <div class="grid">
            <Draggable v-model="keywordList" >
              <transition-group name="fade">
                <el-button
                class="flag-btn"
                size="small"
                v-for="(item, index) in keywordList"
                :key="item.key"
              >
              {{ item.name }}
                <i
                  class="el-icon-close el-icon--right small-del-btn"
                  @click="handleDeleteKeyword(index)"
                >
                </i>
             </el-button>
              </transition-group>
            </Draggable>
            <div class="input-wrap" v-if="addKeyFlag">
              <el-input
                size="small"
                v-model.trim="currentKeyword"
                maxlength="200"
                @blur="hanldeAddKeyword"
                @keyup.native.enter="hanldeAddKeyword"
                placeholder="请输入关键字"
              />
            </div>
            <el-button
              class="small-add-btn"
              icon="el-icon-plus"
              size="small"
              type="primary"
              v-if="!addKeyFlag"
              @click="hanldeAddFlag(true)"
            >
              添加
            </el-button>
            <el-button
              class="small-add-btn"
              size="small"
              v-else
              @click="hanldeAddFlag(false)"
            >
              取消
            </el-button>
          </div>
        </div>
      </div>
      <div class="row multi">
        <div class="tip">平台活动Logo
          <span class="tip-text">
            (建议使用尺寸为80*80px的.png格式透明底图片)
          </span>
        </div>
        <div class="value fill">
          <div class="public-pic-layout">
            <div
              class="fill-pic"
              v-for="(item, index) in navigationBarInformationList"
              :key="index"
            >
              <div class="item" v-if="item.barImage">
                <el-image
                  :ref="`activityImg${index}`"
                  :src="item.barImage"
                  fit="cover"
                  class="icon"
                  :initial-index="0"
                  :preview-src-list="[item.barImage]"
                />
                <div class="preview">
                  <el-image
                    :src="SeeIcon"
                    class="btn-icon"
                    @click="handlePreview(`activityImg${index}`)"
                  />
                  <el-image
                    :src="DelIcon"
                    class="btn-icon"
                    @click="handleDeleteActivityImage(index)"
                  />
                </div>
              </div>
              <div v-else class="item add-pic activity-add-pic" @click="handleActivityUpload(index)">
                <div class="image-wrap">
                  <el-image :src="AddIcon" />
                </div>
                <span class="text">上传图片</span>
              </div>
              <el-input v-model.trim="item.barText" maxlength="5" placeholder="活动名称"  class="desp acitivty-name" size="small"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="tip">客户端客服电话</div>
        <div class="value input">
          <el-input
            size="small"
            placeholder="请输入"
            v-model="formIn.clientCustomerServiceNumber"
            maxlength="16"
          />
        </div>
      </div>
      <div class="row">
        <div class="tip">业务端客服电话</div>
        <div class="value input">
          <el-input
            size="small"
            placeholder="请输入"
            v-model="formIn.serviceCustomerServiceNumber"
            maxlength="16"
          />
        </div>
      </div>
      <div class="row">
        <div class="tip">商户端客服电话</div>
        <div class="value input">
          <el-input
            size="small"
            placeholder="请输入"
            v-model="formIn.merchantCustomerServiceNumber"
            maxlength="16"
          />
        </div>
      </div>
      <div class="row">
        <div class="tip">云药库收款户名</div>
        <div class="value input">
          <el-input
            size="small"
            placeholder="请输入"
            v-model="formIn.yykAccountName"
            :disabled="true"
            maxlength="20"
            
          />
        </div>
      </div>
      <div class="row">
        <div class="tip">开户行</div>
        <div class="value input">
          <el-input
            size="small"
            placeholder="请输入"
            v-model="formIn.bankDeposit"
            maxlength="20"
          />
        </div>
      </div>
      <div class="row">
        <div class="tip">银行卡号</div>
        <div class="value input">
          <el-input
            size="small"
            placeholder="请输入"
            v-model="formIn.bankCardNumber"
            maxlength="20"
          />
        </div>
      </div>
      <div class="row multi">
        <div class="tip">证照信息</div>
        <div class="value fill">
          <div class="grid licenses">
            <div
              class="grid-item"
              v-for="(item, index) in formIn.certificateInformationList"
              :key="index"
            >
              <div class="in-row">
                <div class="value">{{ item.certificateType }}</div>
              </div>
              <div class="in-row">
                <div class="value">{{ item.certificateCode }}</div>
              </div>
              <div class="in-row">
                <div class="value public-pic-layout">
                  <div class="item">
                    <el-image
                      :ref="`myImgCert${index}`"
                      :src="item.certificateImage"
                      fit="cover"
                      class="icon"
                      :initial-index="0"
                      :preview-src-list="[item.certificateImage]"
                    />
                    <div class="preview">
                      <el-image
                        :src="SeeIcon"
                        class="btn-icon"
                        @click="handlePreview(`myImgCert${index}`)"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <i
                class="el-icon-close small-del-btn"
                @click="handleDeleteLicenses(index)"
              ></i>
            </div>
            <div class="public-pic-layout">
              <div class="item add-pic" @click="handleAddLicenses()">
                <div class="image-wrap">
                  <el-image :src="AddIcon" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row multi">
        <div class="tip">链接信息</div>
        <div class="value fill">
          <div class="grid link">
            <div
              class="grid-item"
              v-for="(item, index) in formIn.linkInformationList"
              :key="index"
            >
              <div class="in-row">
                <div class="value">{{ item.linkText }}</div>
              </div>
              <div class="in-row">
                <div class="value">{{ item.linkImage }}</div>
              </div>
              <i
                class="el-icon-close small-del-btn"
                @click="handleDeleteLink(index)"
              ></i>
            </div>
            <div class="public-pic-layout small">
              <div class="item add-pic" @click="handleAddLink()">
                <div class="image-wrap">
                  <el-image :src="AddIcon" />
                </div>
                <span class="text">添加</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-btn">
      <el-button type="primary" class="fix-four" @click="updataBaseInfo(1)">保存</el-button>
      <el-button v-if="0" type="primary" class="fix-four">提交审核</el-button>
    </div>

    <UploadImageView
      ref="imgupload"
      request-id="1"
      :imgType="imgType"
      @upload="uploadSubmit"
    />

    <NewLicensesInfoDlg
      ref="refNewLicensesInfoDlg"
      @addLicenses="handleAddNewLicenses"
    />
    <NewLinkDlg ref="refNewLinkDlg" @addLink="handleAddNewLink" />
  </div>
</template>

<script>
import UploadImageView from "@/views/businessManage/checkShop/components/UploadImage.vue";
import NewLicensesInfoDlg from "../dialog/NewLicensesInfoDlg.vue";
import NewLinkDlg from "../dialog/NewLinkDlg.vue";
import { generateUUId } from "@/views/businessManage/checkShop/util/ViewHelp";
import _ from "lodash";
import { getBaseInfo, updataBaseInfo } from "@/api/platform/index.js";
import Draggable from 'vuedraggable';

const IConst_See_Icon = require("@/assets/zz/see-icon.png");
const IConst_Del_Icon = require("@/assets/zz/del-icon.png");
const IConst_Add_Icon = require("@/assets/zz/add-icon.png");

export default {
  components: { UploadImageView, NewLicensesInfoDlg, NewLinkDlg ,Draggable},
  data() {
    return {
      SeeIcon: IConst_See_Icon,
      DelIcon: IConst_Del_Icon,
      AddIcon: IConst_Add_Icon,

      imgType: "",
      IConst_Max_Pic_Count: 5,
      /**
       * 搜索关键字
       * {
       *  name:"",
       *  key:,
       * }
       */
      keywordList: [], //
      addKeyFlag: false, //是不是正在添加 搜索关键字
      currentKeyword: "", //输入

      formIn: {
        id: "",
        websiteName: "", //网址名称
        searchKeyword: "", //搜索关键字，使用逗号分隔
        clientCustomerServiceNumber: "", //客户端客服电话
        serviceCustomerServiceNumber: "", //业务端客服电话
        merchantCustomerServiceNumber: "", //商户端客服电话
        yykAccountName: "湖南春播云药库科技有限公司", //云药库收款户名
        bankDeposit: "", //开户行
        bankCardNumber: "", //银行卡号
        //平台二维码信息
        qrCodeList: [
          { qrCodeUrl: "", qrCodeName: "客户端app" },
          { qrCodeUrl: "", qrCodeName: "业务端app" },
          { qrCodeUrl: "", qrCodeName: "商户端app" },
          { qrCodeUrl: "", qrCodeName: "客户端小程序" },
          { qrCodeUrl: "", qrCodeName: "微信公众号" },
        ],
        /*//证件信息
        {
          certificateType:"", //证件类型
          certificateCode:"", //证件编码
          certificateImage:"", //证件图片
        }
        */
        certificateInformationList: [], //
        /**
         * 链接信息
         * {
         *  linkText:"", //链接文字
         *  linkImage:"",//链接地址
         * }
         */
        linkInformationList: [],
        navigationBarInformationList: [] //活动信息
      },
      navigationBarInformationList: [
          { barImage: "", barText: "" },
          { barImage: "", barText: "" },
          { barImage: "", barText: "" },
          { barImage: "", barText: "" },
        ] //平台活动
    };
  },
  created() {
    this.doLoadBaseInfo();
  },
  methods: {
    exclude(key) {
      const exList = ["qrCodeList"];
      return exList.includes(key);
    },
    doLoadBaseInfo() {
      getBaseInfo().then((data) => {
        if (data) {
          for (let key in data) {
            if (!this.exclude(key) && this.formIn.hasOwnProperty(key)) {
              this.formIn[key] = data[key];
            }
          }
          if (data.qrCodeList instanceof Array) {
            data.qrCodeList.forEach((item) => {
              const findedItem = this.formIn.qrCodeList.find(
                (subItem) => item.qrCodeName === subItem.qrCodeName
              );
              if (findedItem) {
                findedItem.qrCodeUrl = item.qrCodeUrl;
              }
            });
          }
          if (!this.formIn.certificateInformationList) {
            this.formIn.certificateInformationList = [];
          }
          if (!this.formIn.linkInformationList) {
            this.formIn.linkInformationList = [];
          }
          // 默认四个logo
          this.navigationBarInformationList = this.formIn.navigationBarInformationList ? [...this.formIn.navigationBarInformationList] : this.navigationBarInformationList;
          //
          if (this.formIn.searchKeyword) {
            let arr = this.formIn.searchKeyword.split(",");
            this.keywordList = arr.map((item) => {
              return { name: item, key: generateUUId() };
            });
          }
          this.formIn.yykAccountName = '湖南春播云药库科技有限公司'
        }
      });
    },
    updataBaseInfo() {
      if (!this.formIn.websiteName) {
        this.$message.warning("请输入网站名称");
        return;
      }
      // 处理平台logo
      const hasEmptyLogo = this.navigationBarInformationList.some((item) => {
        return !item.barImage || !item.barText;
      });
      if (hasEmptyLogo) {
        this.$message.warning("平台活动不能为空，图片和文字不能为空");
        return;
      }
      //
      if (this.keywordList instanceof Array && this.keywordList.length > 0) {
        const nameArr = this.keywordList.map((item) => {
          return item.name;
        });
        this.formIn.searchKeyword = nameArr.join(",");
      }
      // 处理平台logo
      this.formIn.navigationBarInformationList = this.navigationBarInformationList;
      const data = _.cloneDeep(this.formIn);
      updataBaseInfo(data).then((data) => {
        this.$message.success("保存成功");
      });
    },
    handleDeleteLicenses(index) {
      this.formIn.certificateInformationList.splice(index, 1);
    },
    handleDeleteLink(index) {
      this.formIn.linkInformationList.splice(index, 1);
    },
    handleAddNewLicenses(item) {
      let newItem = _.cloneDeep(item);
      this.formIn.certificateInformationList.push(newItem);
    },
    handleAddNewLink(item) {
      let newItem = _.cloneDeep(item);
      this.formIn.linkInformationList.push(newItem);
    },
    handleDeleteKeyword(index) {
      this.keywordList.splice(index, 1);
    },
    newKeywordItem(keyword) {
      return {
        name: keyword ? keyword : "",
        id: generateUUId(),
        key: generateUUId(),
      };
    },
    hanldeAddKeyword() {
      console.log('-this.currentKeyword-->',this.currentKeyword);
      if (this.currentKeyword) {
        const item = this.newKeywordItem(this.currentKeyword);
        this.keywordList.push(item);
        this.currentKeyword = "";
        console.log('-this.keywordList-->',this.keywordList);
        //实时保存
        // this.updataBaseInfo()
      }
    },
    hanldeAddFlag(flag) {
      this.addKeyFlag = flag;
    },
    handleAddLicenses() {
      this.$refs.refNewLicensesInfoDlg.open();
    },
    handleAddLink() {
      this.$refs.refNewLinkDlg.open();
    },
    handleUpload(index) {
      this.$refs.imgupload.open(index);
    },
    /**
     * 平台活动上传
     */
    handleActivityUpload(index) {
      this.activityIndex = index
      this.$refs.imgupload.open('activity');
    },
    /**
     * 平台活动图片删除
     */
    handleDeleteActivityImage(index) {
      const item = this.navigationBarInformationList[index];
      item.barImage = "";
    },
    uploadSubmit(obj) {
      console.log('-item-->',obj);
      const { type, url } = obj;
      if(type === 'activity'){
        const item = this.navigationBarInformationList[this.activityIndex]
        item.barImage = url
      }else {
        const item = this.formIn.qrCodeList[type];
        item.qrCodeUrl = url;
      }
    },
    handlePreview(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName][0].showViewer = true;
      }
    },
    handleDeleteImage(index) {
      const item = this.formIn.qrCodeList[index];
      item.qrCodeUrl = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.base-info-root {
  .row {
    .tip {
      width: 7em;
      .tip-text{
        display: inline-block;
        font-size: 12px;
        color: #333;
        margin-top: 3px;
      }
    }

    .grid {
      display: flex;
      flex-wrap: wrap;

      .input-wrap {
        width: 120px;
      }

      & > * {
        margin: 0 8px 8px 0;
      }

      .grid-item {
        width: 220px;
        height: 220px;
        display: flex;
        flex-direction: column;
        border: 1px solid #f2f2f2;
        padding: 16px;
        box-sizing: border-box;
        border-radius: 4px;
        position: relative;

        .small-del-btn {
          position: absolute;
          right: 8px;
          top: 8px;
          cursor: pointer;
        }
      }
      .flag-btn {
        cursor: pointer;
        margin: 8px 8px 0 0;
      }

      .public-pic-layout {
        width: 86px;
      }

      &.link,
      &.licenses {
        .grid-item {
          width: 215px;
          height: 54px;
          background: #f5f5f5;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          padding: 0;
          justify-content: center;

          .in-row {
            padding: 0;
          }
        }
      }

      &.licenses {
        .grid-item {
          height: 160px;
        }
      }
    }
  }

  .in-row {
    display: flex;
    padding: 4px;
    box-sizing: border-box;

    .tip {
      width: 4em;
    }

    .value {
      flex: 1;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .public-pic-layout {
    .fill-pic {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 8px;

      .desp {
        margin-top: 6px;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        color: #262626;
        &.acitivty-name {
          width:  88px;
          text-align: center;
         ::v-deep .el-input__inner {
            padding: 0 6px;
            text-align: center;
          }
        }
      }
    }

    &.small {
      .item {
        width: 68px;
        height: 54px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .text {
          margin-top: 0;
        }
      }
    }
  }
}
.row .value.input {
  width: 240px!important;
}
// .flag-btn {
//   position: relative;
//   &.sortable-chosen{
//     &::before{
//       content: "";
//       width: 1px;
//       height: 32px;
//       background: #333;
//       position: absolute;
//       right: 10;
//       top: 0;
//       bottom: 0;
//     }
// }
// }

</style>
